import { ReactNode } from "react";

interface BadgeProps {
  children: ReactNode;
  variant?: "default" | "outline" | "secondary" | "destructive";
  className?: string;
}

const VARIANT_CLASSES: Record<string, string> = {
  default:     "bg-gray-900 text-white",
  outline:     "border border-gray-200 text-gray-700 bg-transparent",
  secondary:   "bg-gray-100 text-gray-700",
  destructive: "bg-red-100 text-red-700",
};

export function Badge({ children, variant = "default", className = "" }: BadgeProps) {
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ${VARIANT_CLASSES[variant]} ${className}`}>
      {children}
    </span>
  );
}
